import useSWR from 'swr';
import client from 'utils/client';

const fetcher = url => client.head(url).then(res => res.headers);

/**
 * A Custom Hook to check if a User is authenticated.
 * Revalidates, if the user changed tabs or came back to the browser.
 * @returns {{isAuthenticated: boolean}} True if the User is authenticated, False otherwise.
 */
function useIsAuthenticated() {
  const { data, error } = useSWR('/v1.1/status/', fetcher, {});

  return {
    isAuthenticated: !error && data?.['x-authorized'].toLowerCase() === 'true'
  };
}

export default useIsAuthenticated;
